export default "__VITE_ASSET__1a0a5ce9__"